import { todayYmd, daysAgoYmd, dayBoundsYmd } from '../../utils/appTimezone';

export const JOURNAL_PAGE_SIZE = 50;

/** Ajoute société au filtre visite réception lorsque différent de « all ». */
export function withJournalCompanyFilter(query, journalCompanyId) {
  if (journalCompanyId === 'all' || journalCompanyId == null || String(journalCompanyId).trim() === '') {
    return query;
  }
  if (!query) return query;
  const cid = parseInt(String(journalCompanyId), 10);
  if (Number.isNaN(cid) || cid < 1) return query;
  return { ...query, company_id: cid };
}

/** Filtres GET /reception/visits sans pagination. Retourne null si plage invalide. */
export function buildJournalVisitFilters(
  scope,
  rangeFromYYYYMMDD,
  rangeToYYYYMMDD,
  journalCompanyId,
  extraFilters = {}
) {
  const withExtras = (base) => ({ ...base, ...extraFilters });

  if (scope === 'range') {
    const df = String(rangeFromYYYYMMDD || '').trim().slice(0, 10);
    const dt = String(rangeToYYYYMMDD || '').trim().slice(0, 10);
    if (!df || !dt || df.length < 10 || dt.length < 10 || df > dt) return null;
    const { from } = dayBoundsYmd(df);
    const { to } = dayBoundsYmd(dt);
    return withJournalCompanyFilter(
      withExtras({ today: false, from, to }),
      journalCompanyId
    );
  }

  return withJournalCompanyFilter(withExtras({}), journalCompanyId);
}

/** Filtres + pagination pour une page du journal. */
export function buildJournalVisitQuery(
  scope,
  rangeFromYYYYMMDD,
  rangeToYYYYMMDD,
  journalCompanyId,
  extraFilters = {},
  page = 0
) {
  const filters = buildJournalVisitFilters(
    scope,
    rangeFromYYYYMMDD,
    rangeToYYYYMMDD,
    journalCompanyId,
    extraFilters
  );
  if (!filters) return null;
  const safePage = Math.max(0, parseInt(page, 10) || 0);
  return {
    ...filters,
    limit: JOURNAL_PAGE_SIZE,
    offset: safePage * JOURNAL_PAGE_SIZE
  };
}

/** Date calendaire Madagascar (YYYY-MM-DD). */
export function isoDateLocal(d = new Date()) {
  return todayYmd(d);
}

export function defaultJournalRangeIsoDates() {
  return { from: daysAgoYmd(6), to: todayYmd() };
}

/** Plage calendaire : 30 derniers jours (inclus). */
export function defaultJournalMonthRangeIsoDates() {
  return { from: daysAgoYmd(29), to: todayYmd() };
}
